export const panelStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '16px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
};

export const panelHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
};

export const dateRowStyles = {
  display: 'grid',
  gridTemplateColumns: '180px 1fr auto',
  alignItems: 'center',
  gap: '12px',
};
